export const DRM = {
  None: '',
  Clearkey: 'org.w3.clearkey',
  Widevine: 'com.widevine.alpha',
  Fairplay: 'com.apple.fps',
  Playready: 'com.microsoft.playready',
} as const;
export type DRM = (typeof DRM)[keyof typeof DRM];

export type Dropdowns = 'hidden' | 'subtitles' | 'speed' | 'variants' | 'languages';

export type RequestHeaders = {
  [e: string]: string;
};

export type InternalRequestHeaders = {
  name: string;
  value: string;
}[];

export type VideoOptions = {
  /**
   * Video source URL
   */
  source: string;
  /**
   * Whether to display player controls
   */
  controls?: boolean;
  /**
   * Autoplay setting
   */
  autoPlay?: boolean;
  /**
   * Silence audio by default
   */
  muted?: boolean;
  /**
   * DRM type to use
   */
  drm?: DRM;
  /**
   * License URL to use with Widevine or FairPlay
   */
  licenseUrl?: string;
  /**
   * License URL to use with Widevine or FairPlay
   */
  certificateUrl?: string;
  /**
   * Key to use with ClearKey
   */
  clearKey?: string;
  /**
   * KeyID to use with ClearKey
   */
  clearKeyId?: string;
  /**
   * Headers to send to the DRM licensing server
   */
  headers?: RequestHeaders;
  /**
   * Should show stats
   */
  showStats?: boolean;
  /**
   * Optional onReady handler
   */
  onReady?(player: shaka.Player): void;

  serverCertificateUri?: string;
};
